<template>
  <div class="header">
    <v-layout class="header-inner" align-center justify-space-between fill-height row>
      <v-layout text-xs-left xs1 align-center>
        <router-link to="/" class="router-link d-flex align-center">
          <img src="../assets/img/logo.svg" alt="">
          <span class="logo-text ml-2 mr-6">ТЕЛЕПОРТ</span>
        </router-link>
      </v-layout>
      <v-flex text-xs-left xs6 fill-height class="menu">
        <v-tabs
          hide-slider
          active-class="menu-active"
          class="ma-0 pa-0 fill-height d-flex">
          <v-tab v-for="(tab, index) in validateTabs" v-bind:key="index" v-bind:to="tab.route" v-bind:class="{ inactive : !tab.active }">
            {{ tab.title }}
          </v-tab>
        </v-tabs>
      </v-flex>

      <v-spacer />
      <mts-button size="s" class="mr-4" v-on:click.prevent="openModal">Условия проведения торгов</mts-button>
      <v-layout align-center justify-end row class="logo-block">
        <v-menu
          transition="slide-y-transition"
          v-bind:nudge-width="150">
          <template v-slot:activator="{ on }">
            <v-btn v-if="Object.keys(user.userInfo).length > 0" icon class="mr-2" v-on="on">
              <img
                v-bind:src="avatar"
                v-on:error="onerrorAvatar">
            </v-btn>
            <v-btn v-else icon class="mr-2" v-on="on">
              <img src="../assets/img/avatar.svg" alt="">
            </v-btn>
          </template>
          <v-list style="width: 300px;">
            <v-list-tile class="py-3">
              <v-list-tile-avatar>
                <v-icon size="40" color="greyHeather">mdi-account-circle</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{ user.userInfo.name }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ user.userInfo.email }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile class="py-3" v-on:click="logout">
              <v-list-tile-avatar>
                <v-icon color="greyHeather">mdi-run</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>Выход</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <!-- <v-layout column align-end>
              <v-flex>
                <span class="user-info">{{ user.userInfo.name }} {{ user.userInfo.surname }}</span>
              </v-flex>
              <v-flex mt-1>
                <span class="user-info"></span>
              </v-flex>
              <v-btn class="ma-0 mt-2" color="primary" @click="logout">Выйти</v-btn>
            </v-layout> -->
          </v-list>
        </v-menu>
      </v-layout>
    </v-layout>

    <terms-of-use-modal v-bind:show-modal.sync="showModal" />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import TermsOfUseModal from '@/components/Modals/TermsOfUse/TermsOfUseModal.vue';

  export default {
    components: {
      TermsOfUseModal
    },
    data() {
      return {
        showMenu: false,
        avatarError: false,
        currentTab: null,
        showModal: false,
        tabs: [
          {
            title: 'Торги',
            route: '/lots',
            active: true
          },
          {
            title: 'Настройки',
            route: '/admin/references/list',
            active: true
          }
          // {
          //   title: 'Условия',
          //   route: `/terms`,
          //   active: false
          // },
          // {
          //   title: 'Обратная связь',
          //   route: `/feedback`,
          //   active: false
          // },
        ]
      };
    },
    computed: {
      ...mapState({
        user: state => state.user
      }),

      avatar() {
        const avatarTemplate = require('@/assets/img/avatar.svg');
        if (this.user.userInfo && !this.avatarError) {
          return `https://newportal.mts.ru/my/User%20Photos/Profile%20Pictures/ADMSK_${this.user.userInfo.login}_MThumb.jpg`;
        } else if (this.avatarError) {
          return avatarTemplate;
        }
        return avatarTemplate;
      },

      isUserAdmin() {
        if (this.user.userInfo && this.user.userInfo.roles) {
          return this.user.userInfo.roles.map(item => item.code).includes('ADMIN');
        }
        return false;
      },

      validateTabs() {
        if (!this.isUserAdmin) {
          return [];
        }
        return this.tabs;
      }
    },
    created() {
    },
    methods: {
      openModal() {
        this.showModal = true;
      },
      logout() {
        this.$store.dispatch('logout');
      },
      onerrorAvatar() {
        this.avatarError = true;
      }
    }
  };
</script>

<style lang="scss" scoped>
.logo-block {
  width: 4rem;

  img {
    width: 100%;
    border-radius: 50%;
  }
}
.logo-text {
  font-family: 'MTSWide', sans-serif;
  font-size: 17px;
}
</style>
